// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"f149eebf","145":"ceb154c5","161":"b52be8fd","453":"d7446e4a","553":"3ee5bca4","686":"a955738c"}[chunkId] + ".chunk.js";
};